module.exports = __webpack_public_path__ + "media/LP_検索ページ.c6ba1067.mp4";